import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { TaskModalMainHeaderItem } from './task-modal-main/task-modal-main.component';
import { TaskInfoDetailItem } from './task-info/task-info.component';
import {
  ToolingVerificationLevelPipe,
  ToolingInfo,
  MachineInfo,
  PlantInfo,
} from '@schenck/rotec-components';
import { TypeEnumPipe } from '../type-enum.pipe';
import { ToolingTaskInfo } from 'src/api';

export function getToolingTaskModalInfos(
  task$: Observable<ToolingTaskInfo>,
  tooling$: Observable<ToolingInfo>,
  plants$: Observable<PlantInfo[]>,
  machines$: Observable<MachineInfo[]>,
  translate: TranslateService
) {
  return {
    task: task$,
    toolingPictureId: tooling$.pipe(map((tooling) => tooling.pictureId)),
    taskInfos: combineLatest([tooling$, plants$]).pipe(
      map(([tooling, plants]) => {
        return <TaskModalMainHeaderItem[][]>[
          [
            { name: 'Tooling', value: tooling.name },
            { name: 'Serial Number', value: tooling.serial },
            { name: 'Inventory Number', value: tooling.inventoryNo },
            { name: 'Plant(s)', value: plants.map((p) => p.name).join(', ') },
          ],
        ];
      })
    ),
    details: combineLatest([task$, tooling$, machines$]).pipe(
      map(
        ([task, tooling, machines]) =>
          <TaskInfoDetailItem[][]>[
            [
              { name: 'Manufacturer', value: tooling.manufacturer || '-' },
              { name: 'Schenck Material Number', value: tooling.schenckMatNo || '-' },
              { name: 'TOOLING_For Rotor(s)', value: tooling.toolingForRotor || '-' },
              { name: 'Machine(s)', value: machines.map((m) => m.name).join(', ') || '-' },
              { name: 'Storage Location', value: tooling.storageLocation || '-' },
              { name: 'Workplace', value: tooling.workplace || '-' },
              {
                name: 'Verification Level',
                value:
                  ToolingVerificationLevelPipe.translate(tooling.verificationLevel, translate) ||
                  '-',
              },
            ],
            [
              { name: 'Task Responsible', value: task.responsible || '-' },
              {
                name: 'Expected Duration',
                value: task.expectedDurationMinutes
                  ? translate.instant('VALUE Minutes', {
                      value: task.expectedDurationMinutes,
                    })
                  : '-',
              },
              { name: 'Task Type', value: TypeEnumPipe.translate(task.type, translate) },
            ],
          ]
      )
    ),
  };
}
